import { useFormik } from "formik";
import Select from "../../../../components/form/select/Select";
import { useSelector } from "react-redux";
import * as Yup from 'yup';
import { FileUploader } from "react-drag-drop-files";
import { useEffect, useState } from "react";
import useFileUpload from "../../../../utils/hooks/useFileUpload";
import ViewFiles from "../../../../components/modals/claims/ViewFiles";
import RichTextEditor from "../../../../components/form/RichTextEditor";
import { BsArrowLeft } from "react-icons/bs";
import { createSavingsClaim, resetClaimStatus, resetTempCoverInfo, setTempCoverInfo } from "../../../../redux/slice/claim/savingClaimSlice";
import { useDispatch } from "react-redux";
import { getSavingsClaimDetails } from "../../../../redux/slice/claim/savingClaimSlice";
import { flashMessage } from "../../../../utils/flash";
import { isEmptyObjectValues } from "../../../../utils/helpers/filter";
import { useNavigate } from "react-router-dom";
import { getClaimProcessSettings } from "../../../../redux/slice/claim/claimSlice";
import { debounce } from "lodash";

export const joinBy_ = (parameter) => {
    return parameter
      .toLowerCase()
      .replace(/[^\w\s]/g, "")
      .replace(/\s+/g, "_");
};

const flattenObject = (object) => {
    const objectData = {};
    if (object) {
      for (const element of object) {
        objectData[element] = "";
      }
      return objectData;
    }
  };

const claimsCategory = [
    { name: "Other Cover", id: "other_cover" },
    { name: "Savings Claim", id: "savings_claim" },
];

const claimsType = [
    { name: "Maturity", id: "1" },
    { name: "Termination", id: "2" },
    { name: "Partial Withdrawal", id: "3" },
    { name: "Death Benefit", id: "4" },
];

export const formatDynamicValues = (values, fieldDefinitions) => {
    const dynamicFields = [];
  
    // Loop through the field definitions
    for (const definition of fieldDefinitions) {
      const field_name = joinBy_(definition.field_name.toLowerCase());
      const field_type = definition.field_type;
      const compulsory_field = definition.compulsory_field;
  
      // Check if the field_name exists in the values object
      if (values.hasOwnProperty(field_name)) {
        // Create a dynamic field object based on the values and definition
        const dynamicField = {
          field_name,
          field_type,
          compulsory_field,
          value: values[field_name],
        };
  
        // Push the dynamic field object to the dynamicFields array
        dynamicFields.push(dynamicField);
      }
    }
    return dynamicFields;
};

const today = new Date().toISOString().split("T")[0];

const CoverInfo = ({policyHolderRef}) => {
    const [fileList, setFileList] = useState([]);
    const [selectedFile, setSelectedFile] = useState("");
    const [isUploading, setIsUploading] = useState(false);
    const [detailsOfLoss, setDetailsOfLoss] = useState("");
    const [desc, setDesc] = useState("");
    const [disable, setDisable] = useState(null);

  const { policyHolder, isLoading, claim_details, tempCoverInfo, createSuccess } = useSelector((state) => state.savingsClaim);
  const { policy_cover, claim_process_settings, } = useSelector((state) => state.claim);

  const { user } = useSelector((state) => state.auth.user);
  
  const { fileUrl, singleFileUpload } = useFileUpload();

  const dispatch = useDispatch();
  const navigate = useNavigate();

    const onSubmit = (values) => {
        if (fileList.length < 1) {
          flashMessage("error", "Document is required");
          return;
        }
        let payload = {
           garranty_type: values.guaranty_type,
            claim_category: values.claim_category,
            claim_type: values.claim_type,
            total_premium_paid: policyHolder?.total_deposit,
            claim_amount: values.claim_amount,
            date_of_loss: values.date_of_loss,
            premium_paid_date: policyHolder?.last_payment_date,
            reason_for_claim: values.reason_for_claim,
            life_insurance: values.life_insurance,
            amount_payable: values.amount_payable,
            interest: values.interest,
            total_contribution_paid: values.total_contribution_paid,
            new_balance_after_with_drawal_fee: values.new_balance_after_with_drawal_fee,
            balance_in_account: values.balance_in_account,
            last_contribution_date: values.last_contribution_date,
            termination_fee: values.termination_fee,
            with_drawal_fee: values.with_drawal_fee,
            desc: desc,
            details_of_loss: detailsOfLoss,
            policy_cover: values.policy_cover,
            policy_id: policyHolder?.policy_app_details?.policy_id,
            customer_id: policyHolder?.policy_app_details?.customerId,
            policy_application_number: policyHolder?.policy_app_details?.policyAppNumber,
            documents: fileList,
            claim_form: formatDynamicValues(
              values,
              claim_details?.claim_form ? claim_details.claim_form : claim_process_settings?.get_claim_form
            ),
            staff_id: user?.staff_id
        };
        dispatch(createSavingsClaim(payload));
    };

    const handleCustomFileChange = (name, e) => {
        e.preventDefault();
        singleFileUpload(e.target.files[0]);
        setSelectedFile(name);
    };

    const handleFileChange = (file) => {
        setDisable(true);
        setIsUploading(true);
        singleFileUpload(file);
        setSelectedFile("document-upload");
    };

    const validationSchema = Yup.object({
        claim_category: Yup.string().required('Claims category is required'),
        // Add other validation rules as necessary
      });


    const {
        values,
        errors,
        touched,
        handleBlur,
        handleChange,
        handleSubmit,
        setFieldValue,
      } = useFormik({
        // enableReinitialize: true,
        initialValues: tempCoverInfo
            ? tempCoverInfo
            : {
                claim_category: "",
                claim_type: "",
                policy_cover: "",
                date_of_loss: "",
                premium_paid_date: "",
                claim_amount: "",
                total_premium_paid: "",
                total_contribution_paid: "",
                termination_fee: "",
                reason_for_claim: "",
                life_insurance: claim_details ? claim_details.life_insurance : "",
                balance_in_account: "",
                interest: "",
                amount_payable:"",
                last_contribution_date: "",
                with_drawal_fee: "",
                guaranty_type: "",
                document: [],
                ...flattenObject(
                    claim_details?.claim_form?.map((item) =>
                    joinBy_(item?.field_name)
                    )
                ),
                ...flattenObject(
                  claim_process_settings?.get_claim_form?.map((item) =>
                    joinBy_(item?.field_name)
                  )
                ),
                },
        validationSchema,
        validate: (values) => {
          let errors = {};
          let customFormCompulsoryFields =
            claim_details?.claim_form?.filter(
              (items) => items?.compulsory_field === 1
            );
          let customFormCompulsoryFields2 =
          claim_process_settings?.get_claim_form?.filter(
              (items) => items?.compulsory_field === 1
            );
          customFormCompulsoryFields?.forEach((field) => {
            const fieldName = joinBy_(field?.field_name);
            const value = values[fieldName];
    
            if (value === "") {
              errors[fieldName] = fieldName + " is required.";
            }
          });
          customFormCompulsoryFields2?.forEach((field) => {
            const fieldName = joinBy_(field?.field_name);
            const value = values[fieldName];
    
            if (value === "") {
              errors[fieldName] = fieldName + " is required.";
            }
          });
          if (!values?.policy_cover && values?.claim_category === "other_cover") {
            errors.policy_cover = "policy cover is required.";
          }
    
          return errors;
        },
        onSubmit,
      });

      const claimsCategoryData = claimsCategory?.map((cat) => {
        return {
          label: cat.name,
          value: cat.id,
        };
      });

      const filteredClaimsType = policyHolder?.policy_app_details?.status === "3" 
        ? claimsType.filter(type => type.name === "Maturity") 
        : claimsType.filter(type => type.name !== "Maturity");

      const claimsTypeData = filteredClaimsType.map((type) => {
        return {
          label: type.name,
          value: type.id,
        };
      });

      // New state for tracking user input of amount_payable
      const [amountChanged, setAmountChanged] = useState(false)

      // Update userAmountPayable state on input change
      const handleAmountPayableChange = (e) => {
        setFieldValue('amount_payable', e.target.value);
        setAmountChanged(true);
      };

      const debouncedFetch = debounce(() => {
        if (amountChanged && values.claim_category === 'savings_claim' && values.claim_type && values.claim_type !== '4') {
          dispatch(resetTempCoverInfo())
          dispatch(getSavingsClaimDetails({
            claim_category: values.claim_category,
            claim_type: values.claim_type,
            policy_id: policyHolder.policy_app_details.policy_id,
            customer_id: policyHolder.policy_app_details.customerId,
            policy_application_number: policyHolder.policy_app_details.policyAppNumber,
            amount_payable: values.amount_payable,
          }));
          setAmountChanged(false);
        }
      }, 2000); // 2 seconds delay
    
      useEffect(() => {
        debouncedFetch();
        return () => {
          debouncedFetch.cancel();
        };
      }, [values.amount_payable, dispatch, values.claim_category, values.claim_type, policyHolder.policy_app_details.policy_id, policyHolder.policy_app_details.customerId, policyHolder.policy_app_details.policyAppNumber, amountChanged]);

      
    useEffect(() => {
    if (fileUrl && selectedFile === "document-upload") {
        setIsUploading(false);
        let fileIndex = fileList?.findIndex((file) => file === fileUrl);
        if (fileIndex < 0) {
        setFileList([...fileList, fileUrl]);
        }
        return;
    }

    if (selectedFile !== "document-upload") {
        setFieldValue(selectedFile, fileUrl);
        setSelectedFile("file-upload");
    }
    // setFileList(tempCoverInfo?.document);
    }, [fileUrl, tempCoverInfo?.document]);

    useEffect(() => {
        if (isUploading) {
          setDisable(isUploading);
        } else if (isEmptyObjectValues(errors)) {
          setDisable(isEmptyObjectValues(errors));
        } else {
          setDisable(false);
        }
      }, [isUploading, values]);      

    useEffect(() => {
        if (claim_details !== null) {          
          setFieldValue('life_insurance', claim_details.life_insurance)
          setFieldValue('balance_in_account', parseInt(claim_details.balance_in_account));
          setFieldValue('interest', claim_details.interest);
          setFieldValue('amount_payable', claim_details.amount_payable);
          setFieldValue('total_contribution_paid', claim_details.total_contribution_paid);
          setFieldValue('termination_fee', claim_details.termination_fee);
          setFieldValue('last_contribution_date', claim_details.last_contribution_date);
          setFieldValue('with_drawal_fee', claim_details.with_drawal_fee);
          setFieldValue('guaranty_type', claim_details.garranty_type);
        } else {         
          setFieldValue('life_insurance', "")
          setFieldValue('balance_in_account', "");
          setFieldValue('interest', "");
          setFieldValue('amount_payable', "");
          setFieldValue('total_contribution_paid', "");
          setFieldValue('termination_fee', "");
          setFieldValue('last_contribution_date', "");
          setFieldValue('with_drawal_fee', "");
          setFieldValue('guaranty_type', "");
        }
    }, [claim_details, setFieldValue]);
    
    useEffect(() => {
      if (values.claim_category === 'savings_claim' && values.claim_type) {
        dispatch(getSavingsClaimDetails({
            claim_category: values.claim_category,
            claim_type: values.claim_type,
            policy_id: policyHolder.policy_app_details.policy_id,
            customer_id: policyHolder.policy_app_details.customerId,
            policy_application_number: policyHolder.policy_app_details.policyAppNumber,
            amount_payable: null
        }))
      }
    }, [dispatch, policyHolder.policy_app_details.customerId, policyHolder.policy_app_details.policyAppNumber, policyHolder.policy_app_details.policy_id, values.claim_category, values.claim_type])

    useEffect(() => {
      if (values.policy_cover) {
        dispatch(
          getClaimProcessSettings({
            policy_cover: values?.policy_cover,
            policy_id: policyHolder?.policy_app_details?.policy_id,
          })
        );
        // setPolicyCover(values.policy_cover);
        // setFileList([]);
      }
    }, [values?.policy_cover]);

    // console.log(claim_process_settings);
    
    useEffect(() => {
      if (createSuccess) {
        navigate("/admin/claims/all-savings-claims");
        setFileList([]);
        resetClaimStatus();
        console.log(createSuccess);
      }
    }, [createSuccess, navigate]);
    
  return (
    <div className='row mx-2 sm-mx-0'>
        <div className='col-md-6'>
            <div className="mb-2">
                <label htmlFor='account_type' className={`form-label mt-1`}>
                    Claims Category <span className='text-danger'>*</span>
                </label>
                <Select
                    onBlur={() => {
                      handleBlur({ target: { name: "claim_category" } });
                    }}
                    name='claim_category'
                    data={claimsCategoryData}
                    value={values?.claim_category}
                    onChange={(selectedOption) =>
                      setFieldValue("claim_category", selectedOption?.value)
                    }
                />
                {errors?.claim_category &&
                touched?.claim_category &&
                !values?.claim_category && (
                    <p className='mb-0 text-danger'>
                    {errors?.claim_category + "*"}
                    </p>
                )}
            </div>
            <div>
            {(values.claim_category === "savings_claim") && <div>
                  <label htmlFor='account_type' className={`form-label mt-1`}>
                    Claims Type <span className='text-danger'>*</span>
                  </label>
                  <Select
                    onBlur={() => {
                      handleBlur({ target: { name: "claim_type" } });
                    }}
                    name='claim_type'
                    data={claimsTypeData}
                    value={values?.claim_type}
                    onChange={(selectedOption) =>
                      setFieldValue("claim_type", selectedOption?.value)
                    }
                  />
                  {errors?.claim_type &&
                    touched?.claim_type &&
                    !values?.claim_type && (
                      <p className='mb-0 text-danger'>
                        {errors?.claim_type + "*"}
                      </p>
                    )}
                </div>}
            </div>
            <div>
            {(values.claim_category === "other_cover") && <div>
                <label htmlFor='account_type' className={`form-label mt-1`}>
                    Policy Cover<span className='text-danger'>*</span>
                </label>
                <Select
                    onBlur={() => {
                        handleBlur({ target: { name: "policy_cover" } });
                    }}
                    name='policy_cover'
                    // data={coverData ? coverData : []}
                    data={policy_cover?.policy_cover?.map((item) => ({
                      value: item.cover,
                      label: item.cover_name,
                    }))}
                    value={values?.policy_cover}
                    onChange={(selectedOption) =>
                        setFieldValue("policy_cover", selectedOption?.value)
                }
                />
                  {errors?.claim_type &&
                    touched?.claim_type &&
                    !values?.claim_type && (
                      <p className='mb-0 text-danger'>
                        {errors?.claim_type + "*"}
                      </p>
                    )}
                </div>}
            </div>
        </div>
        <form onSubmit={handleSubmit}>
            <input
            autocomplete='false'
            name='hidden'
            type='text'
            style={{ display: "none" }}
            />
            <div className='col-md-12 my-3'>
                {values?.claim_category && <div>
                    <h1 className='fs-4 mb-1'>Claims Details</h1>
                </div>}
            </div>
            {claim_details?.message && <div class="alert alert-warning mb-3" role="alert">
              {claim_details?.message}
            </div>}
            {values.claim_category === 'savings_claim' && <div className='row'>
                {((values.claim_type === "3" || values.claim_type === "4") && values.claim_category === "savings_claim") && <div className='col-sm-6 col-md-4 mb-3'>
                    <label htmlFor='last_contribution_date' className='form-label'>
                        Last contribution date <span className='text-danger'>*</span>
                    </label>
                    <input
                        type='date'
                        className={`form-control form-control-sm`}
                        name='last_contribution_date'
                        id='last_contribution_date'
                        defaultValue={values?.last_contribution_date}
                        value={values?.last_contribution_date}
                        disabled
                        onChange={handleChange}
                        // onBlur={handleBlur}
                    />
                    {/* {errors.premium_paid_date && touched.premium_paid_date ? (
                        <span className='fs-5 invalid-feedback'>
                        {errors.premium_paid_date}
                        </span>
                    ) : null} */}
                </div>}
                {(values.claim_type !== "1" && values.claim_category === "savings_claim") && <div className='col-sm-6 col-md-4 mb-3'>
                    <label htmlFor='total_contribution_paid' className='form-label'>
                        Total Contribution <span className='text-danger'>*</span>
                    </label>
                    <input
                        type='number'
                        className={`form-control form-control-sm`}
                        name='total_contribution_paid'
                        id='total_contribution_paid'
                        defaultValue={values?.total_contribution_paid}
                        value={values?.total_contribution_paid}
                        disabled
                        onChange={handleChange}
                        onBlur={handleBlur}
                    />
                    {/* {errors.premium_paid_date && touched.premium_paid_date ? (
                        <span className='fs-5 invalid-feedback'>
                        {errors.premium_paid_date}
                        </span>
                    ) : null} */}
                </div>}
                {(values.claim_category !== "other_cover") && <div className='col-sm-6 col-md-4 mb-3'>
                    <label htmlFor='premium_paid_date' className='form-label'>
                        Life insurance <span className='text-danger'>*</span>
                    </label>
                    <input
                        type='number'
                        className={`form-control form-control-sm`}
                        name='life_insurance'
                        id='life_insurance'
                        defaultValue={values.life_insurance}
                        value={values.life_insurance}
                        disabled
                        onChange={handleChange}
                        onBlur={handleBlur}
                    />
                    {errors.life_insurance && touched.life_insurance ? (
                        <span className='fs-5 invalid-feedback'>
                        {errors.life_insurance}
                        </span>
                    ) : null}
                </div>}
                {(values.claim_category !== "other_cover") && <div className='col-sm-6 col-md-4 mb-3'>
                    <label htmlFor='premium_paid_date' className='form-label'>
                        Balance in account <span className='text-danger'>*</span>
                    </label>
                    <input
                        type='number'
                        className={`form-control form-control-sm`}
                        name='balance_in_account'
                        id='balance_in_account'
                        defaultValue={values?.balance_in_account}
                        disabled
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values?.balance_in_account}
                    />
                    {errors.balance_in_account && touched.balance_in_account ? (
                        <span className='fs-5 invalid-feedback'>
                        {errors.balance_in_account}
                        </span>
                    ) : null}
                </div>}
                {(values.claim_type === "1" && values.claim_category === "savings_claim") && <div className='col-sm-6 col-md-4 mb-3'>
                    <label htmlFor='premium_paid_date' className='form-label'>
                        Interest <span className='text-danger'>*</span>
                    </label>
                    <input
                        type='number'
                        className={`form-control form-control-sm`}
                        name='interest'
                        id='interest'
                        defaultValue={values?.interest}
                        disabled
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values?.interest}
                    />
                    {/* {errors.interest && touched.interest ? (
                        <span className='fs-5 invalid-feedback'>
                        {errors.interest}
                        </span>
                    ) : null} */}
                </div>}
                {(values.claim_type === "2" && values.claim_category === "savings_claim") && <div className='col-sm-6 col-md-4 mb-3'>
                    <label htmlFor='termination_fee' className='form-label'>
                        Termination Fee <span className='text-danger'>*</span>
                    </label>
                    <input
                        type='number'
                        className={`form-control form-control-sm`}
                        name='termination_fee'
                        id='termination_fee'
                        defaultValue={values?.termination_fee}
                        disabled
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values?.termination_fee}
                    />
                    {/* {errors.premium_paid_date && touched.premium_paid_date ? (
                        <span className='fs-5 invalid-feedback'>
                        {errors.premium_paid_date}
                        </span>
                    ) : null} */}
                </div>}
                {(values.claim_category !== "other_cover") && <div className='col-sm-6 col-md-4 mb-3'>
                    <label htmlFor='premium_paid_date' className='form-label'>
                        Amount Payable <span className='text-danger'>*</span>
                    </label>
                    <input
                        type="number"
                        className={`form-control form-control-sm`}
                        name='amount_payable'
                        id='amount_payable'
                        defaultValue={values?.amount_payable}
                        disabled={values?.claim_type !== '3' && values?.guaranty_type !== 'range'}
                        onChange={handleAmountPayableChange}
                        onBlur={handleBlur}
                        value={values?.amount_payable}
                    />
                    {/* {errors.amount_payable && touched.amount_payable ? (
                        <span className='fs-5 invalid-feedback'>
                        {errors.amount_payable}
                        </span>
                    ) : null} */}
                </div>}
                {(values.claim_type === "3" && values.claim_category === "savings_claim") && <div className='col-sm-6 col-md-4 mb-3'>
                    <label htmlFor='premium_paid_date' className='form-label'>
                        Withdrawal Fee <span className='text-danger'>*</span>
                    </label>
                    <input
                        type='number'
                        className={`form-control form-control-sm`}
                        name='with_drawal_fee'
                        id='with_drawal_fee'
                        defaultValue={values?.with_drawal_fee}
                        disabled
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values?.with_drawal_fee}
                    />
                    {/* {errors.premium_paid_date && touched.premium_paid_date ? (
                        <span className='fs-5 invalid-feedback'>
                        {errors.premium_paid_date}
                        </span>
                    ) : null} */}
                </div>}
                <div className='col-sm-6 col-md-4 mb-3'>
                    <label htmlFor='date_of_loss' className='form-label'>
                        Upload Document
                        <span className='text-danger'>*</span>
                        {isUploading && (
                        <span>
                            <i className='mdi mdi-dots-circle mdi-spin'></i>{" "}
                        </span>
                        )}
                        {fileList?.length > 0 &&
                        !isUploading &&
                        selectedFile === "document-upload" && (
                            <span>
                            <i className='mdi mdi-check'></i>
                            </span>
                        )}
                    </label>
                <div>
                <FileUploader
                  label='Browse Document'
                  children={
                    <div
                      className={`border-dotted p-1 px-4 text-center cursor-p ${
                        errors.document && "is-invalid"
                      }`}
                      style={{ border: "2px dashed grey" }}
                      onClick={() => setSelectedFile("document-upload")}
                    >
                      <i className='uil uil-cloud-upload fs-4'></i> Upload
                      Document
                      <span className='text-primary-dark mt-0'></span>
                    </div>
                  }
                  handleChange={handleFileChange}
                  onBlur={handleBlur}
                  // onDrop={handleChange}
                  name='file'
                  types={["JPG", "PNG", "PDF"]}
                />
                </div>
                    {fileList?.length ? (
                        <div className='mt-1 sm-mt-3'>
                        {fileList?.length} file{fileList?.length > 1 && "s"} uploaded{" "}
                        <span
                            className='text-info cursor-p'
                            data-bs-toggle='modal'
                            data-bs-target='#view_file'
                        >
                            view
                        </span>
                        </div>
                    ) : null}
                </div>
            </div>}
            {values.claim_category === 'other_cover' && <div className='row'>
                <div className='col-sm-6 col-md-4 mb-3'>
                <label htmlFor='premium_paid_date' className='form-label'>
                    Last premium paid Date <span className='text-danger'>*</span>
                </label>
                <input
                    type='date'
                    className={`form-control form-control-sm`}
                    name='premium_paid_date'
                    id='premium_paid_date'
                    defaultValue={policyHolder?.last_payment_date}
                    disabled
                    // onChange={handleChange}
                    // onBlur={handleBlur}
                />
                {/* {errors.premium_paid_date && touched.premium_paid_date ? (
                    <span className='fs-5 invalid-feedback'>
                    {errors.premium_paid_date}
                    </span>
                ) : null} */}
                </div>
                <div className='col-sm-6 col-md-4 mb-3'>
                <label htmlFor='claim_amount' className='form-label'>
                    Claim Amount <span className='text-danger'>*</span>
                </label>
                <input
                    type='number'
                    name='claim_amount'
                    id='claim_amount'
                    value={values.claim_amount}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={`form-control form-control-sm ${
                    errors.claim_amount && touched.claim_amount && "is-invalid"
                    }`}
                />
                {errors.claim_amount && touched.claim_amount ? (
                    <span className='fs-5 invalid-feedback'>
                    {errors.claim_amount}
                    </span>
                ) : null}
                </div>
                <div className='col-sm-6 col-md-4 mb-3'>
                <label htmlFor='total_premium_paid' className='form-label'>
                    Total Premium paid <span className='text-danger'>*</span>
                </label>
                <input
                    type='text'
                    name='total_premium_paid'
                    id='total_premium_paid'
                    defaultValue={policyHolder?.total_deposit}
                    className={`form-control form-control-sm`}
                    disabled
                />
                </div>
                <div className='col-sm-6 col-md-4 mb-3'>
                <label htmlFor='reason_for_claim' className='form-label'>
                    Reason for Claim <span className='text-danger'>*</span>
                </label>
                <input
                    onChange={handleChange}
                    onBlur={handleBlur}
                    name='reason_for_claim'
                    value={values.reason_for_claim}
                    id='reason_for_claim'
                    className={`form-control form-control-sm ${
                    errors.reason_for_claim &&
                    touched.reason_for_claim &&
                    "is-invalid"
                    }`}
                />
                {errors.reason_for_claim && touched.reason_for_claim ? (
                    <span className='fs-5 invalid-feedback'>
                    {errors.reason_for_claim}
                    </span>
                ) : null}
                </div>
                <div className='col-sm-6 col-md-4 mb-3'>
                <label htmlFor='date_of_loss' className='form-label'>
                    Date of Loss <span className='text-danger'>*</span>
                </label>
                <input
                    type='date'
                    name='date_of_loss'
                    id='date_of_loss'
                    value={values.date_of_loss}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    max={today}
                    className={`form-control form-control-sm ${
                    errors.date_of_loss && touched.date_of_loss && "is-invalid"
                    }`}
                />
                {errors.date_of_loss && touched.date_of_loss ? (
                    <span className='fs-5 invalid-feedback'>
                    {errors.date_of_loss}
                    </span>
                ) : null}
                </div>
                <div className='col-sm-6 col-md-4 mb-3'>
              <label htmlFor='date_of_loss' className='form-label'>
                Upload Document
                <span className='text-danger'>*</span>
                {isUploading && (
                  <span>
                    <i className='mdi mdi-dots-circle mdi-spin'></i>{" "}
                  </span>
                )}
                {fileList?.length > 0 &&
                  !isUploading &&
                  selectedFile === "document-upload" && (
                    <span>
                      <i className='mdi mdi-check'></i>
                    </span>
                  )}
              </label>
              <div>
                <FileUploader
                  label='Browse Document'
                  children={
                    <div
                      className={`border-dotted p-1 px-4 text-center cursor-p ${
                        errors.document && "is-invalid"
                      }`}
                      style={{ border: "2px dashed grey" }}
                      onClick={() => setSelectedFile("document-upload")}
                    >
                      <i className='uil uil-cloud-upload fs-4'></i> Upload
                      Document
                      <span className='text-primary-dark mt-0'></span>
                    </div>
                  }
                  handleChange={handleFileChange}
                  onBlur={handleBlur}
                  // onDrop={handleChange}
                  name='file'
                //   types={fileTypes}
                />
              </div>
              {fileList?.length ? (
                <div className='mt-1 sm-mt-3'>
                  {fileList?.length} file{fileList?.length > 1 && "s"} uploaded{" "}
                  <span
                    className='text-info cursor-p'
                    data-bs-toggle='modal'
                    data-bs-target='#view_file'
                  >
                    view
                  </span>
                </div>
              ) : null}
            </div>
            </div>}
            {values.claim_category === 'savings_claim' && <div className="row">
                <div className='mb-3' style={{ height: "250px" }}>
                <label htmlFor='description' className='mb-1'>
                    Description
                </label>
                <RichTextEditor
                    name='description'
                    id='description'
                    value={desc}
                    onChange={(value) => setDesc(value)}
                    height='200px'
                />
                </div>
            </div>}
            {values.claim_category === 'other_cover' && <div className="row">
                <div className='mb-3' style={{ height: "250px" }}>
                <label htmlFor='description' className='mb-1'>
                    Details of Loss
                </label>
                <RichTextEditor
                    name='description'
                    id='description'
                    value={detailsOfLoss}
                    onChange={(value) => setDetailsOfLoss(value)}
                    height='200px'
                />
                </div>
            </div>}
            <section>
            {values.claim_category === 'other_cover' && <section>
              <div>
                <h1 className='fs-4 mb-1'>Custom Form</h1>
                <p>
                  (field from the custom form associated with the selected policy
                  cover will be displayed here)
                </p>
              </div>
              <div className='row'>
                {claim_process_settings?.get_claim_form &&
                  claim_process_settings?.get_claim_form?.map(
                    (customForm, index) => {
                      return (
                        <div className='mb-3 col-sm-9 col-md-7' key={index}>
                          {/* For inputs that are not checkbox */}
                          {customForm?.field_type !== "checkbox" &&
                          customForm?.field_type !== "file" &&
                          customForm?.field_type !== "button" ? (
                            <div>
                              <label htmlFor=''>
                                {customForm?.field_name.charAt(0).toUpperCase() +
                                  customForm?.field_name?.slice(1)}
                              </label>
                              {customForm?.compulsory_field === 1 ? (
                                <span className='text-danger ms-1'>*</span>
                              ) : null}
                              <div>
                                <input
                                  type={`${customForm?.field_type}`}
                                  name={`${joinBy_(customForm?.field_name)}`}
                                  className={`form-control form-control-sm`}
                                  onChange={handleChange}
                                  value={values[joinBy_(customForm?.field_name)]}
                                  onBlur={handleBlur}
                                  autoComplete='off'
                                />
                              </div>
                              {customForm?.compulsory_field === 1 &&
                              errors[joinBy_(customForm.field_name)] &&
                              touched[joinBy_(customForm.field_name)] ? (
                                <span className='text-danger'>
                                  {customForm.field_name} is required
                                </span>
                              ) : null}
                            </div>
                          ) : null}
                          {/* For checkbox input */}
                          {customForm?.field_type === "checkbox" && (
                            <div>
                              <div class='form-check'>
                                <input
                                  class={`form-check-input ${
                                    errors[joinBy_(customForm?.field_name)] &&
                                    touched[joinBy_(customForm?.field_name)]
                                  } `}
                                  type='checkbox'
                                  name={`${joinBy_(customForm?.field_name)}`}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                />
                                <label
                                  className='form-check-label'
                                  for='flexCheckDefault'
                                  style={{ marginTop: "2px" }}
                                >
                                  {customForm?.field_name.charAt(0).toUpperCase() +
                                    customForm?.field_name?.slice(1)}
                                </label>
                                {customForm?.compulsory_field === 1 && (
                                  <span className='text-danger ms-1'>*</span>
                                )}
                              </div>
                            </div>
                          )}
                          {/* For file inputs */}
                          {customForm?.field_type === "file" ? (
                            <div>
                              <label htmlFor=''>
                                {customForm?.field_name.charAt(0).toUpperCase() +
                                  customForm?.field_name?.slice(1)}
                              </label>
                              {customForm?.compulsory_field === 1 && (
                                <span className='text-danger ms-1'>*</span>
                              )}
                              <div>
                                <input
                                  type={`${customForm?.field_type}`}
                                  name={`${joinBy_(customForm?.field_name)}`}
                                  accept='.pdf, image/*'
                                  className={`form-control form-control-sm`}
                                  onChange={(e) =>
                                    handleCustomFileChange(
                                      `${joinBy_(customForm?.field_name)}`,
                                      e
                                    )
                                  }
                                  onBlur={handleBlur}
                                />
                                {customForm?.compulsory_field === 1 &&
                                errors[joinBy_(customForm.field_name)] &&
                                touched[joinBy_(customForm.field_name)] ? (
                                  <span className='text-danger'>
                                    {customForm.field_name} is required
                                  </span>
                                ) : null}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      );
                    }
                  )}
              </div>
            </section>}
                {claim_details && <div className="my-3">
                    <h1 className='fs-4 mb-1'>Custom Form</h1>
                    <p>
                        (field from the custom form associated with the selected policy
                        cover will be displayed here)
                    </p>
                </div>}
                <div className='row'>
                    {claim_details?.claim_form &&
                    claim_details?.claim_form?.map(
                        (customForm, index) => {
                        return (
                            <div className='mb-3 col-sm-9 col-md-7' key={index}>
                            {/* For inputs that are not checkbox */}
                            {customForm?.field_type !== "checkbox" &&
                            customForm?.field_type !== "file" &&
                            customForm?.field_type !== "button" ? (
                                <div>
                                <label htmlFor=''>
                                    {customForm?.field_name.charAt(0).toUpperCase() +
                                    customForm?.field_name?.slice(1)}
                                </label>
                                {customForm?.compulsory_field === 1 ? (
                                    <span className='text-danger ms-1'>*</span>
                                ) : null}
                                <div>
                                    <input
                                    type={`${customForm?.field_type}`}
                                    name={`${joinBy_(customForm?.field_name)}`}
                                    className={`form-control form-control-sm`}
                                    onChange={handleChange}
                                    value={values[joinBy_(customForm?.field_name)]}
                                    onBlur={handleBlur}
                                    autoComplete='off'
                                    />
                                </div>
                                {customForm?.compulsory_field === 1 &&
                                errors[joinBy_(customForm.field_name)] &&
                                touched[joinBy_(customForm.field_name)] ? (
                                    <span className='text-danger'>
                                    {customForm.field_name} is required
                                    </span>
                                ) : null}
                                </div>
                            ) : null}
                            {/* For checkbox input */}
                            {customForm?.field_type === "checkbox" && (
                                <div>
                                <div class='form-check'>
                                    <input
                                    class={`form-check-input ${
                                        errors[joinBy_(customForm?.field_name)] &&
                                        touched[joinBy_(customForm?.field_name)]
                                    } `}
                                    type='checkbox'
                                    name={`${joinBy_(customForm?.field_name)}`}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    />
                                    <label
                                    className='form-check-label'
                                    for='flexCheckDefault'
                                    style={{ marginTop: "2px" }}
                                    >
                                    {customForm?.field_name.charAt(0).toUpperCase() +
                                        customForm?.field_name?.slice(1)}
                                    </label>
                                    {customForm?.compulsory_field === 1 && (
                                    <span className='text-danger ms-1'>*</span>
                                    )}
                                </div>
                                </div>
                            )}
                            {/* For file inputs */}
                            {customForm?.field_type === "file" ? (
                                <div>
                                <label htmlFor=''>
                                    {customForm?.field_name.charAt(0).toUpperCase() +
                                    customForm?.field_name?.slice(1)}
                                </label>
                                {customForm?.compulsory_field === 1 && (
                                    <span className='text-danger ms-1'>*</span>
                                )}
                                <div>
                                    <input
                                    type={`${customForm?.field_type}`}
                                    name={`${joinBy_(customForm?.field_name)}`}
                                    accept='.pdf, image/*'
                                    className={`form-control form-control-sm`}
                                    onChange={(e) =>
                                        handleCustomFileChange(
                                        `${joinBy_(customForm?.field_name)}`,
                                        e
                                        )
                                    }
                                    onBlur={handleBlur}
                                    />
                                    {customForm?.compulsory_field === 1 &&
                                    errors[joinBy_(customForm.field_name)] &&
                                    touched[joinBy_(customForm.field_name)] ? (
                                    <span className='text-danger'>
                                        {customForm.field_name} is required
                                    </span>
                                    ) : null}
                                </div>
                                </div>
                            ) : null}
                            </div>
                        );
                        }
                    )}
                </div>
                <div className='d-flex justify-content-end gap-2 mt-2'>
                    <button
                        type='button'
                        className='btn btn-sm btn-info '
                        onClick={() => {
                        dispatch(setTempCoverInfo({ ...values, document: fileList }));
                        policyHolderRef.current?.click();
                        }}
                    >
                        <BsArrowLeft className='me-1' size={18} />
                        <span>Previous</span>
                    </button>
                    <button
                        type='submit'
                        disabled={disable}
                        className='btn btn-sm btn-primary'
                    >
                        <span>Submit</span>
                    </button>
                </div>
            </section>
        </form>
        <ViewFiles modal_id='view_file' fileList={fileList} />
    </div>
  )
}

export default CoverInfo